module.exports = __webpack_public_path__ + "static/img/mapinguari.ab84c99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/projects/mapinguari.png
// module id = SVK3
// module chunks = 0